import { Row, Col, Card, DatePicker, Select, Button, Tooltip } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import ExportToExcel from "./ExportToExcel";

const { RangePicker } = DatePicker;
const { Option } = Select;

export default function FiltrosDashboard({
  departamentoId,
  municipioId,
  fechaInicio,
  fechaFin,
  departamentos,
  municipios,
  onSelectDepto,
  setMunicipioId,
  setFechaInicio,
  setFechaFin,
  limpiarFiltros,
  loading,
  exportData
}) {
  const handleDateChange = (dates) => {
    if (!dates || dates.length === 0) {
      setFechaInicio(null);
      setFechaFin(null);
    } else {
      setFechaInicio(dates[0]);
      setFechaFin(dates[1]);
    }
  };

  const formatDateDisplay = (date) => {
    if (!date) return null;
    return dayjs(date);
  };

  return (
    <Card 
      style={{ marginBottom: 20, borderRadius: 12 }}
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span>Filtros de Dashboard</span>
        </div>
      }
    >
      <Row gutter={16} wrap={false} style={{ alignItems: "center" }}>
        <Col flex="180px">
          <Select
            value={departamentoId}
            onChange={onSelectDepto}
            placeholder="Departamentos"
            allowClear
            style={{ width: "100%" }}
            loading={loading}
            disabled={loading}
          >
            {departamentos.map((d) => (
              <Option key={d.oid} value={d.oid}>
                {d.departamento}
              </Option>
            ))}
          </Select>
        </Col>
        
        <Col flex="180px">
          <Select
            value={municipioId}
            onChange={setMunicipioId}
            placeholder="Municipios"
            disabled={!departamentoId || loading}
            allowClear
            style={{ width: "100%" }}
            loading={loading}
          >
            {municipios.map((m) => (
              <Option key={m.oid} value={m.oid}>
                {m.municipio}
              </Option>
            ))}
          </Select>
        </Col>
        
        <Col flex="280px">
          <RangePicker
            placeholder={["Fecha inicio", "Fecha fin"]}
            format="YYYY-MM-DD"
            style={{ width: "100%" }}
            value={[
              formatDateDisplay(fechaInicio),
              formatDateDisplay(fechaFin)
            ]}
            onChange={handleDateChange}
            disabled={loading}
            allowClear={true}
          />
        </Col>
        <Col flex="auto">
          <div style={{ display: "flex", flexDirection: "row", gap: 8, justifyContent: "flex-end" }}>
            <Tooltip title="Limpiar todos los filtros">
              <Button 
                danger 
                onClick={limpiarFiltros}
                disabled={loading}
                icon={<ReloadOutlined />}
              >
                Limpiar
              </Button>
            </Tooltip>
            <ExportToExcel 
              data={exportData} 
              loading={loading}
            />
          </div>
        </Col>
      </Row>
      {(departamentoId || municipioId || fechaInicio || fechaFin) && (
        <div style={{ marginTop: 12, fontSize: 12, color: '#666' }}>
          <span>Filtros activos: </span>
          {departamentoId && (
            <span style={{ backgroundColor: '#f0f0f0', padding: '2px 6px', borderRadius: 4, marginRight: 6 }}>
              Depto: {departamentos.find(d => d.oid === departamentoId)?.departamento}
            </span>
          )}
          {municipioId && (
            <span style={{ backgroundColor: '#f0f0f0', padding: '2px 6px', borderRadius: 4, marginRight: 6 }}>
              Munic: {municipios.find(m => m.oid === municipioId)?.municipio}
            </span>
          )}
          {fechaInicio && fechaFin && (
            <span style={{ backgroundColor: '#f0f0f0', padding: '2px 6px', borderRadius: 4 }}>
              {dayjs(fechaInicio).format('DD/MM/YY')} - {dayjs(fechaFin).format('DD/MM/YY')}
            </span>
          )}
        </div>
      )}
    </Card>
  );
}